import React, {useEffect, useState} from "react";
import {DATE_FORMAT, prettifyCurrency} from "@bounce/shared/helpers";
import {SinglePaymentDate} from "./SinglePaymentDate";
import {PlanStartDate} from "./PlanStartDate";
import dayjs from "dayjs";
import {IPaymentScheduleComponents} from "./PaymentSchdule";
import {Button} from "@bounce/shared/ui";
import {useUserMetaData} from "../../../../../../../../contexts";
import {useGetEndDate} from "../useGetEndDate";
import {getLastDate} from "../utils";

export const HardshipPaymentSchedule = ({
  selectedPlan,
  setSelectedPlan,
  resetSelectedPlan,
  handleNext,
  isPreview,
}: IPaymentScheduleComponents) => {
  const {accountId} = useUserMetaData();
  const today = dayjs().format(DATE_FORMAT);
  const [firstStartDate, setFirstStartDate] = useState<string>(selectedPlan.first_plan_details.start_date || today);
  const [firstEndDate, setFirstEndDate] = useState<string>(today);
  const [mainStartDate, setMainStartDate] = useState<string>(selectedPlan.start_date || today);
  const [mainEndDate, setMainEndDate] = useState<string>(today);

  const {fetchEndDate: fetchFirstEndDate} = useGetEndDate({
    accountId,
    startDate: firstStartDate,
    frequency: selectedPlan.installment_frequency,
    numberOfInstallments: selectedPlan.first_plan_details.number_of_installments,
    installmentSize: selectedPlan.first_plan_details.installment_size,
    setEndDate: setFirstEndDate,
  });

  const {fetchEndDate: fetchMainEndDate} = useGetEndDate({
    accountId,
    startDate: mainStartDate,
    frequency: selectedPlan.installment_frequency,
    numberOfInstallments: selectedPlan.number_of_installments,
    installmentSize: selectedPlan.installment_size,
    setEndDate: setMainEndDate,
  });

  const clickNext = () => {
    handleNext();
    const updatedSelectedPlan = {...selectedPlan};
    updatedSelectedPlan.first_plan_details.start_date = dayjs(firstStartDate).format(DATE_FORMAT);
    updatedSelectedPlan.start_date = dayjs(mainStartDate).format(DATE_FORMAT);
    setSelectedPlan(updatedSelectedPlan);
  };

  useEffect(() => {
    fetchFirstEndDate();
  }, [firstStartDate, selectedPlan]);

  useEffect(() => {
    if (resetSelectedPlan) {
      const newDate = getLastDate(dayjs(firstEndDate), selectedPlan.installment_frequency);
      setMainStartDate(newDate.format(DATE_FORMAT));
    }
  }, [firstEndDate, selectedPlan]);

  useEffect(() => {
    fetchMainEndDate();
  }, [mainStartDate, selectedPlan]);

  if (!selectedPlan.first_plan_details) {
    return null;
  }
  const minDate = selectedPlan.first_plan_details.number_of_installments === 1 ? firstStartDate : firstEndDate;
  return (
    <>
      {selectedPlan.first_plan_details.number_of_installments === 1 ? (
        <SinglePaymentDate
          field={`Hardship payment [${prettifyCurrency(selectedPlan.first_plan_details.installment_size)}]`}
          date={firstStartDate}
          setDate={setFirstStartDate}
          maxDate
        />
      ) : (
        <PlanStartDate
          field={`Hardship payments [${selectedPlan.first_plan_details.number_of_installments} X ${prettifyCurrency(
            selectedPlan.first_plan_details.installment_size
          )}]`}
          startDate={firstStartDate}
          setStartDate={setFirstStartDate}
          endDate={firstEndDate}
          maxDate
        />
      )}
      {selectedPlan.number_of_installments === 1 ? (
        <SinglePaymentDate
          field={`Lump sum [${prettifyCurrency(selectedPlan.installment_size)}]`}
          date={mainStartDate}
          setDate={setMainStartDate}
          minDate={minDate}
        />
      ) : (
        <PlanStartDate
          field={`Remaining plan [${selectedPlan.number_of_installments} X ${prettifyCurrency(
            selectedPlan.installment_size
          )}]`}
          startDate={mainStartDate}
          setStartDate={setMainStartDate}
          endDate={mainEndDate}
          minDate={minDate}
        />
      )}
      {!isPreview && (
        <Button fullWidth onClick={clickNext} size={"medium"}>
          Proceed to payment
        </Button>
      )}
    </>
  );
};
